import { readEnvVariable } from '.';
import { getFeatureFlagValue } from './network';
import { setMenuUnificationFeatureFlag } from './session-storage';

export type UnleashUpdateContext = (context: {
  userId: string;
}) => Promise<void>;

const UNIFIED_MENU_FLAG = 'unified_menu';

/** Restaurant codes that always use brand menu — skip Unleash toggle fetch */
export const isBrandMenuOnlyRestaurantCode = (restaurantCode: string) =>
  /dq|dairy_queen/i.test(restaurantCode);

/**
 * Updates Unleash client context for the restaurant, then sets sessionStorage
 * for the unified_menu path (DQ shortcut or REST toggle fetch).
 */
export async function resolveUnifiedMenuUnleashFlag(
  restaurantCode: string,
  updateContext: UnleashUpdateContext
): Promise<void> {
  if (isBrandMenuOnlyRestaurantCode(restaurantCode)) {
    setMenuUnificationFeatureFlag('true');
    return;
  }
  await updateContext({ userId: restaurantCode });

  const bmFeatureFlag = await getFeatureFlagValue({
    url: `${readEnvVariable('UNLEASH_API_URL')}?userId=${restaurantCode}`,
    name: UNIFIED_MENU_FLAG,
  });
  setMenuUnificationFeatureFlag(bmFeatureFlag.toString());
}
